import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Keyboard, Zoom } from "swiper/modules";
import { Box } from "@gemini/core";
import { useGalleryContext } from "@/components/Gallery/contexts";
import { SliderButtons } from "./Controls/SliderButtons";
import { SliderIndicator } from "./Controls/SliderIndicator";
import { ResponsiveImage } from "../ResponsiveImage/ResponsiveImage";
import { SlideDescription } from "./Controls/SlideDescription";
import { FloorplanSurvey } from "../FloorplanSurvey/FloorplanSurvey";
export const SwiperSlider = ({ medias, extraSlides, onContainerPress, showFloorplanSurvey = false, showControls = true, testId, }) => {
    const { currentStep } = useGalleryContext();
    const DOUBLE_TAP_DELAY = 200;
    const lastTap = useRef(0);
    const timeoutRef = useRef(null);
    // Handle single click with delay to differentiate from double click for zoom
    const handleClick = () => {
        const now = Date.now();
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        if (now - lastTap.current < DOUBLE_TAP_DELAY) {
            return;
        }
        lastTap.current = now;
        timeoutRef.current = setTimeout(() => onContainerPress === null || onContainerPress === void 0 ? void 0 : onContainerPress(), DOUBLE_TAP_DELAY);
    };
    return (_jsx(Box, { position: "relative", display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "100%", onClick: handleClick, testId: testId, children: _jsxs(Swiper, { style: { height: "100%", width: "100%" }, keyboard: {
                enabled: true,
            }, zoom: true, modules: [Keyboard, Zoom], initialSlide: currentStep || 0, children: [medias.map((media) => (_jsxs(SwiperSlide, { style: {
                        height: "100%",
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }, children: [_jsxs("div", { className: "swiper-zoom-container", children: [_jsx(ResponsiveImage, { image: media }), _jsx("div", { className: "swiper-lazy-preloader swiper-lazy-preloader-white" })] }), showFloorplanSurvey && _jsx(FloorplanSurvey, { mediaID: media.key }), showControls && (_jsx(SlideDescription, { description: media === null || media === void 0 ? void 0 : media.description }))] }, media.key))), extraSlides === null || extraSlides === void 0 ? void 0 : extraSlides.map((ExtraSlide) => (_jsx(SwiperSlide, { style: {
                        height: "100%",
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }, children: _jsx(ExtraSlide, {}) }, ExtraSlide.name))), showControls && (_jsxs(_Fragment, { children: [_jsx(SliderIndicator, { total: medias.length }), _jsx(SliderButtons, {})] }))] }) }));
};
